module.exports = __webpack_public_path__ + "static/media/hand_shake.15eb23cf.svg";